module.exports = require('./src/ScrollLock');



//////////////////
// WEBPACK FOOTER
// ./~/react-scrolllock/index.js
// module id = 361
// module chunks = 120937046367186